import { render, staticRenderFns } from "./ResumeUploader.vue?vue&type=template&id=40b4b0aa&scoped=true&"
import script from "./ResumeUploader.vue?vue&type=script&lang=js&"
export * from "./ResumeUploader.vue?vue&type=script&lang=js&"
import style0 from "./ResumeUploader.vue?vue&type=style&index=0&id=40b4b0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4b0aa",
  null
  
)

export default component.exports